export const globalServicesManager = {
  header: {
    title: "Services and experiences",
    description: "One list for your whole account. Write each service once and tick which listings offer it.",
  },

  toolbar: {
    info: "What you create here shows on your <strong>booking engine</strong> and your <strong>website</strong>, on the listings you tick.",
    newService: "New service",
  },

  loading: "Loading services…",

  empty: {
    title: "No services yet",
    description: "A transfer, a guided tour, a welcome basket… Guests add them while booking.",
    create: "Create the first one",
  },

  status: {
    active: "Active",
    paused: "Paused",
  },

  price: {
    onRequest: "On request",
    free: "Free",
  },

  assign: {
    title: "Which listings offer it",
    listingsLabel: "Your listings",
    selectAll: "Select all",
    clearAll: "Clear all",
    inAll: "On every listing",
    inSome: "On {n} of {total}",
    units: "{n} units",
    pickRooms: "Choose rooms",
    hideRooms: "Hide rooms",
    roomsHint: "Tick only the rooms where it is offered. With none ticked, it is offered in all of them.",
    inRooms: "In 1 room | In {count} rooms",
    unassigned: "Not assigned",
    helperNone: "With nothing ticked, this service is NOT offered anywhere.",
    roomsChecked: "1 ticked · clear | {count} ticked · clear",
    andMore: "+1 more | +{count} more",
    helper: "With none ticked, the service is offered on all your listings.",
  },

  actions: {
    edit: "Edit",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
  },

  delete: {
    title: "Delete the service",
    text: "“{name}” will stop being offered on all your listings. This cannot be undone.",
    accept: "Yes, delete",
  },

  saved: {
    assign: "Listings updated",
    state: "Service updated",
    deleted: "Service deleted",
  },

  errors: {
    load: "We couldn't load your services.",
    assign: "We couldn't save the listings.",
    state: "We couldn't change the service.",
    delete: "We couldn't delete the service.",
  },
};
